import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/cross_white.svg'
import _imports_1 from '@/assets/img/cross.svg'


const _withScopeId = n => (_pushScopeId("data-v-e150f636"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "opModal formContainer" }
const _hoisted_2 = {
  key: 0,
  class: "errorMessage"
}
const _hoisted_3 = { class: "header" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { class: "body" }
const _hoisted_8 = { class: "mt-4" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-sm-5" }
const _hoisted_11 = { class: "col-sm-5" }
const _hoisted_12 = { class: "col-sm-2 d-flex align-items-center justify-content-end" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_15 = { class: "table table-striped" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { colspan: "99" }
const _hoisted_19 = { class: "d-flex justify-content-end" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = { class: "text-center mt-5" }
const _hoisted_22 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createTextVNode(_toDisplayString(_ctx.errorMessage) + " ", 1),
          _createElementVNode("img", {
            src: _imports_0,
            class: "pointer",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.errorMessage = ''))
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_localized_text, {
          localizedKey: "Embroidery material composition",
          text: "Embroidery material composition"
        })
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-modal-close",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
      }, _hoisted_6)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_form_field, {
              type: "select-string",
              labelKey: "Material",
              labelValue: "Material",
              placeholderKey: "Material",
              placeholderValue: "Material",
              list: _ctx.filteredMaterials,
              modelValue: _ctx.tempMaterialName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tempMaterialName) = $event))
            }, null, 8, ["list", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_form_field, {
              type: "number",
              labelKey: "Percentage (Remaining{{remainingPercentage}})",
              labelValue: "Percentage (Remaining {{remainingPercentage}}%)",
              labelObject: { remainingPercentage: _ctx.remainingPercentage},
              disabled: _ctx.disablePercentage,
              placeholderKey: "Percentage",
              placeholderValue: "Percentage",
              modelValue: _ctx.tempMaterialPercentage,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tempMaterialPercentage) = $event))
            }, null, 8, ["labelObject", "disabled", "modelValue"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              type: "button",
              class: "btn btn-tertiary",
              disabled: _ctx.adddisabled,
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.addLayer && _ctx.addLayer(...args)))
            }, [
              _createVNode(_component_localized_text, {
                localizedKey: "Add",
                text: "Add"
              })
            ], 8, _hoisted_13)
          ])
        ]),
        _hoisted_14,
        _createElementVNode("table", _hoisted_15, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Material",
                  text: "Material"
                })
              ]),
              _createElementVNode("td", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "Percentage",
                  text: "Percentage"
                })
              ]),
              _hoisted_16
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_ctx.localModel.length == 0)
              ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                  _createElementVNode("td", _hoisted_18, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "No Elements Found",
                      text: "No Elements Found"
                    })
                  ])
                ]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.localModel, (item, i) => {
              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                _createElementVNode("td", null, _toDisplayString(item.key), 1),
                _createElementVNode("td", null, _toDisplayString(item.value) + "%", 1),
                _createElementVNode("td", _hoisted_19, [
                  _createElementVNode("button", {
                    class: "btn btn-primary",
                    onClick: ($event: any) => (_ctx.removeMaterial(i))
                  }, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Remove",
                      text: "Remove"
                    })
                  ], 8, _hoisted_20)
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-tertiary",
          disabled: _ctx.disabled,
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args)))
        }, [
          _createVNode(_component_localized_text, {
            localizedKey: "Confirm",
            text: "Confirm"
          })
        ], 8, _hoisted_22)
      ])
    ])
  ]))
}